import getMessage from 'src/background/utils/i18n.utils';
import Joi from 'joi';
import { capitalize } from 'lodash';
import Logger from 'src/utils/logger.utils';
const FormValidationError = {
    ['string.empty']: 'validation_error_mandatory',
    ['number.base']: 'validation_error_mandatory',
    ['number.less']: 'validation_error_greater_than_value',
    ['number.max']: 'validation_error_less_or_equal_value',
    ['number.positive']: 'popup_html_need_positive_amount',
};
const parseJoiError = (error) => {
    var _a, _b;
    Logger.error('Error in form: ', error);
    if (error.type === 'number.min')
        return capitalize((_a = error.message) === null || _a === void 0 ? void 0 : _a.replace(/"/g, ''));
    let errMessage = getMessage(FormValidationError[error.type], ((_b = error.ref) === null || _b === void 0 ? void 0 : _b.value) ? [error.ref.value] : []);
    return errMessage;
};
const createRules = (data) => {
    return Joi.object(data).unknown(true);
};
export const FormUtils = { parseJoiError, createRules };
